// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_org_profile from "../../commonapis/gen/buhta_common_v1_org_profile.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_wkt__Google_protobuf_timestamp from "../../third_party/google_wkt/gen/google_protobuf_timestamp.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";
import * as Stdlib__Bytes from "melange/bytes.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_key.ml",
      127,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "KeyContent"
                          ],
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "Key"
                    ]]
                },
                "V1"
              ]]
          },
          "Keychain"
        ]]
    });

const Keychain = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_key.ml",
      217,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "KeyContent"
                    ],
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "Key"
              ]]
          },
          "V1"
        ]]
    });

const V1 = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_key.ml",
      305,
      10
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "KeyContent"
              ],
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "Key"
        ]]
    });

const Key = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_key.ml",
      391,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "KeyContent"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const KeyContent = Caml_module.init_mod([
      "proto/keychainapis/gen/buhta_keychain_v1_key.ml",
      423,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.keychain.v1.Key.KeyContent";
}

function make(passwordOpt, p12Opt, param) {
  const password = passwordOpt !== undefined ? passwordOpt : "";
  const p12 = p12Opt !== undefined ? p12Opt : Stdlib__Bytes.of_string("");
  return {
          password: password,
          p12: p12
        };
}

const merge_password = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "password",
            "password"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_p12 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "p12",
            "p12"
          ],
          Ocaml_protoc_plugin__Spec.bytes,
          Stdlib__Bytes.of_string("")
        ]));

function merge(t1, t2) {
  return {
          password: Curry._2(merge_password, t1.password, t2.password),
          p12: Curry._2(merge_p12, t1.p12, t2.p12)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "password",
                    "password"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "p12",
                        "p12"
                      ],
                      Ocaml_protoc_plugin__Spec.bytes,
                      Stdlib__Bytes.of_string("")
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._3(serialize, writer, param.password, param.p12);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(password, p12) {
  return {
          password: password,
          p12: p12
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.keychain.v1.Key.KeyContent", spec(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.password, param.p12);
  };
}

function constructor$1(password, p12) {
  return {
          password: password,
          p12: p12
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.keychain.v1.Key.KeyContent", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, KeyContent, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.keychain.v1.Key";
}

function make$1(idOpt, org, nameOpt, key_usageOpt, key_serial_noOpt, key_userOpt, algOpt, content, subject_iinOpt, subject_binOpt, subject_fullnameOpt, subject_organizationOpt, issuerOpt, issue_time, expire_time, validOpt, ocsp_statusOpt, ocsp_revokedOpt, ocsp_revoke_reasonOpt, ocsp_revoke_time, crl_revokedOpt, crl_statusOpt, crl_revoked_byOpt, crl_revoke_reasonOpt, crl_revoke_time, create_time, param) {
  const id = idOpt !== undefined ? idOpt : 0;
  const name = nameOpt !== undefined ? nameOpt : "";
  const key_usage = key_usageOpt !== undefined ? key_usageOpt : "";
  const key_serial_no = key_serial_noOpt !== undefined ? key_serial_noOpt : "";
  const key_user = key_userOpt !== undefined ? key_userOpt : /* [] */0;
  const alg = algOpt !== undefined ? algOpt : "";
  const subject_iin = subject_iinOpt !== undefined ? subject_iinOpt : "";
  const subject_bin = subject_binOpt !== undefined ? subject_binOpt : "";
  const subject_fullname = subject_fullnameOpt !== undefined ? subject_fullnameOpt : "";
  const subject_organization = subject_organizationOpt !== undefined ? subject_organizationOpt : "";
  const issuer = issuerOpt !== undefined ? issuerOpt : "";
  const valid = validOpt !== undefined ? validOpt : false;
  const ocsp_status = ocsp_statusOpt !== undefined ? ocsp_statusOpt : "";
  const ocsp_revoked = ocsp_revokedOpt !== undefined ? ocsp_revokedOpt : false;
  const ocsp_revoke_reason = ocsp_revoke_reasonOpt !== undefined ? ocsp_revoke_reasonOpt : false;
  const crl_revoked = crl_revokedOpt !== undefined ? crl_revokedOpt : false;
  const crl_status = crl_statusOpt !== undefined ? crl_statusOpt : "";
  const crl_revoked_by = crl_revoked_byOpt !== undefined ? crl_revoked_byOpt : "";
  const crl_revoke_reason = crl_revoke_reasonOpt !== undefined ? crl_revoke_reasonOpt : "";
  return {
          id: id,
          org: org,
          name: name,
          key_usage: key_usage,
          key_serial_no: key_serial_no,
          key_user: key_user,
          alg: alg,
          content: content,
          subject_iin: subject_iin,
          subject_bin: subject_bin,
          subject_fullname: subject_fullname,
          subject_organization: subject_organization,
          issuer: issuer,
          issue_time: issue_time,
          expire_time: expire_time,
          valid: valid,
          ocsp_status: ocsp_status,
          ocsp_revoked: ocsp_revoked,
          ocsp_revoke_reason: ocsp_revoke_reason,
          ocsp_revoke_time: ocsp_revoke_time,
          crl_revoked: crl_revoked,
          crl_status: crl_status,
          crl_revoked_by: crl_revoked_by,
          crl_revoke_reason: crl_revoke_reason,
          crl_revoke_time: crl_revoke_time,
          create_time: create_time
        };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.int64_int,
          0
        ]));

const $$let = Buhta_commonapis__Buhta_common_v1_org_profile.Buhta.Common.V1.OrgProfile;

const merge_org = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "org",
            "org"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

const merge_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "name",
            "name"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_key_usage = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            4,
            "key_usage",
            "keyUsage"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_key_serial_no = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            5,
            "key_serial_no",
            "keySerialNo"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_key_user = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            6,
            "key_user",
            "keyUser"
          ],
          Ocaml_protoc_plugin__Spec.string,
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

const merge_alg = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            7,
            "alg",
            "alg"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_content = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            8,
            "content",
            "content"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: KeyContent.name,
                make: KeyContent.make,
                from_proto: KeyContent.from_proto,
                from_proto_exn: KeyContent.from_proto_exn,
                to_proto: KeyContent.to_proto,
                to_proto$p: KeyContent.to_proto$p,
                merge: KeyContent.merge,
                to_json: KeyContent.to_json,
                from_json_exn: KeyContent.from_json_exn,
                from_json: KeyContent.from_json
              })
        ]));

const merge_subject_iin = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            9,
            "subject_iin",
            "subjectIin"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_subject_bin = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            10,
            "subject_bin",
            "subjectBin"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_subject_fullname = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            11,
            "subject_fullname",
            "subjectFullname"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_subject_organization = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            12,
            "subject_organization",
            "subjectOrganization"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_issuer = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            13,
            "issuer",
            "issuer"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let$1 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_issue_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            14,
            "issue_time",
            "issueTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

const $$let$2 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_expire_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            15,
            "expire_time",
            "expireTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              })
        ]));

const merge_valid = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            16,
            "valid",
            "valid"
          ],
          Ocaml_protoc_plugin__Spec.bool,
          false
        ]));

const merge_ocsp_status = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            17,
            "ocsp_status",
            "ocspStatus"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_ocsp_revoked = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            18,
            "ocsp_revoked",
            "ocspRevoked"
          ],
          Ocaml_protoc_plugin__Spec.bool,
          false
        ]));

const merge_ocsp_revoke_reason = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            19,
            "ocsp_revoke_reason",
            "ocspRevokeReason"
          ],
          Ocaml_protoc_plugin__Spec.bool,
          false
        ]));

const $$let$3 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_ocsp_revoke_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            20,
            "ocsp_revoke_time",
            "ocspRevokeTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$3.name,
                make: $$let$3.make,
                from_proto: $$let$3.from_proto,
                from_proto_exn: $$let$3.from_proto_exn,
                to_proto: $$let$3.to_proto,
                to_proto$p: $$let$3.to_proto$p,
                merge: $$let$3.merge,
                to_json: $$let$3.to_json,
                from_json_exn: $$let$3.from_json_exn,
                from_json: $$let$3.from_json
              })
        ]));

const merge_crl_revoked = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            21,
            "crl_revoked",
            "crlRevoked"
          ],
          Ocaml_protoc_plugin__Spec.bool,
          false
        ]));

const merge_crl_status = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            22,
            "crl_status",
            "crlStatus"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_crl_revoked_by = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            23,
            "crl_revoked_by",
            "crlRevokedBy"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_crl_revoke_reason = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            24,
            "crl_revoke_reason",
            "crlRevokeReason"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const $$let$4 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_crl_revoke_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            25,
            "crl_revoke_time",
            "crlRevokeTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$4.name,
                make: $$let$4.make,
                from_proto: $$let$4.from_proto,
                from_proto_exn: $$let$4.from_proto_exn,
                to_proto: $$let$4.to_proto,
                to_proto$p: $$let$4.to_proto$p,
                merge: $$let$4.merge,
                to_json: $$let$4.to_json,
                from_json_exn: $$let$4.from_json_exn,
                from_json: $$let$4.from_json
              })
        ]));

const $$let$5 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;

const merge_create_time = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            26,
            "create_time",
            "createTime"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$5.name,
                make: $$let$5.make,
                from_proto: $$let$5.from_proto,
                from_proto_exn: $$let$5.from_proto_exn,
                to_proto: $$let$5.to_proto,
                to_proto$p: $$let$5.to_proto$p,
                merge: $$let$5.merge,
                to_json: $$let$5.to_json,
                from_json_exn: $$let$5.from_json_exn,
                from_json: $$let$5.from_json
              })
        ]));

function merge$1(t1, t2) {
  return {
          id: Curry._2(merge_id, t1.id, t2.id),
          org: Curry._2(merge_org, t1.org, t2.org),
          name: Curry._2(merge_name, t1.name, t2.name),
          key_usage: Curry._2(merge_key_usage, t1.key_usage, t2.key_usage),
          key_serial_no: Curry._2(merge_key_serial_no, t1.key_serial_no, t2.key_serial_no),
          key_user: Curry._2(merge_key_user, t1.key_user, t2.key_user),
          alg: Curry._2(merge_alg, t1.alg, t2.alg),
          content: Curry._2(merge_content, t1.content, t2.content),
          subject_iin: Curry._2(merge_subject_iin, t1.subject_iin, t2.subject_iin),
          subject_bin: Curry._2(merge_subject_bin, t1.subject_bin, t2.subject_bin),
          subject_fullname: Curry._2(merge_subject_fullname, t1.subject_fullname, t2.subject_fullname),
          subject_organization: Curry._2(merge_subject_organization, t1.subject_organization, t2.subject_organization),
          issuer: Curry._2(merge_issuer, t1.issuer, t2.issuer),
          issue_time: Curry._2(merge_issue_time, t1.issue_time, t2.issue_time),
          expire_time: Curry._2(merge_expire_time, t1.expire_time, t2.expire_time),
          valid: Curry._2(merge_valid, t1.valid, t2.valid),
          ocsp_status: Curry._2(merge_ocsp_status, t1.ocsp_status, t2.ocsp_status),
          ocsp_revoked: Curry._2(merge_ocsp_revoked, t1.ocsp_revoked, t2.ocsp_revoked),
          ocsp_revoke_reason: Curry._2(merge_ocsp_revoke_reason, t1.ocsp_revoke_reason, t2.ocsp_revoke_reason),
          ocsp_revoke_time: Curry._2(merge_ocsp_revoke_time, t1.ocsp_revoke_time, t2.ocsp_revoke_time),
          crl_revoked: Curry._2(merge_crl_revoked, t1.crl_revoked, t2.crl_revoked),
          crl_status: Curry._2(merge_crl_status, t1.crl_status, t2.crl_status),
          crl_revoked_by: Curry._2(merge_crl_revoked_by, t1.crl_revoked_by, t2.crl_revoked_by),
          crl_revoke_reason: Curry._2(merge_crl_revoke_reason, t1.crl_revoke_reason, t2.crl_revoke_reason),
          crl_revoke_time: Curry._2(merge_crl_revoke_time, t1.crl_revoke_time, t2.crl_revoke_time),
          create_time: Curry._2(merge_create_time, t1.create_time, t2.create_time)
        };
}

function spec$1(param) {
  const $$let = Buhta_commonapis__Buhta_common_v1_org_profile.Buhta.Common.V1.OrgProfile;
  const $$let$1 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$2 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$3 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$4 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  const $$let$5 = Google_wkt__Google_protobuf_timestamp.Google.Protobuf.Timestamp;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.int64_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "org",
                        "org"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: $$let.name,
                            make: $$let.make,
                            from_proto: $$let.from_proto,
                            from_proto_exn: $$let.from_proto_exn,
                            to_proto: $$let.to_proto,
                            to_proto$p: $$let.to_proto$p,
                            merge: $$let.merge,
                            to_json: $$let.to_json,
                            from_json_exn: $$let.from_json_exn,
                            from_json: $$let.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "name",
                            "name"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                4,
                                "key_usage",
                                "keyUsage"
                              ],
                              Ocaml_protoc_plugin__Spec.string,
                              ""
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                  [
                                    5,
                                    "key_serial_no",
                                    "keySerialNo"
                                  ],
                                  Ocaml_protoc_plugin__Spec.string,
                                  ""
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                                      [
                                        6,
                                        "key_user",
                                        "keyUser"
                                      ],
                                      Ocaml_protoc_plugin__Spec.string,
                                      Ocaml_protoc_plugin__Spec.not_packed
                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                          [
                                            7,
                                            "alg",
                                            "alg"
                                          ],
                                          Ocaml_protoc_plugin__Spec.string,
                                          ""
                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                              [
                                                8,
                                                "content",
                                                "content"
                                              ],
                                              Ocaml_protoc_plugin__Spec.message({
                                                    name: KeyContent.name,
                                                    make: KeyContent.make,
                                                    from_proto: KeyContent.from_proto,
                                                    from_proto_exn: KeyContent.from_proto_exn,
                                                    to_proto: KeyContent.to_proto,
                                                    to_proto$p: KeyContent.to_proto$p,
                                                    merge: KeyContent.merge,
                                                    to_json: KeyContent.to_json,
                                                    from_json_exn: KeyContent.from_json_exn,
                                                    from_json: KeyContent.from_json
                                                  })
                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                  [
                                                    9,
                                                    "subject_iin",
                                                    "subjectIin"
                                                  ],
                                                  Ocaml_protoc_plugin__Spec.string,
                                                  ""
                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                      [
                                                        10,
                                                        "subject_bin",
                                                        "subjectBin"
                                                      ],
                                                      Ocaml_protoc_plugin__Spec.string,
                                                      ""
                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                          [
                                                            11,
                                                            "subject_fullname",
                                                            "subjectFullname"
                                                          ],
                                                          Ocaml_protoc_plugin__Spec.string,
                                                          ""
                                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                              [
                                                                12,
                                                                "subject_organization",
                                                                "subjectOrganization"
                                                              ],
                                                              Ocaml_protoc_plugin__Spec.string,
                                                              ""
                                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                  [
                                                                    13,
                                                                    "issuer",
                                                                    "issuer"
                                                                  ],
                                                                  Ocaml_protoc_plugin__Spec.string,
                                                                  ""
                                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                                      [
                                                                        14,
                                                                        "issue_time",
                                                                        "issueTime"
                                                                      ],
                                                                      Ocaml_protoc_plugin__Spec.message({
                                                                            name: $$let$1.name,
                                                                            make: $$let$1.make,
                                                                            from_proto: $$let$1.from_proto,
                                                                            from_proto_exn: $$let$1.from_proto_exn,
                                                                            to_proto: $$let$1.to_proto,
                                                                            to_proto$p: $$let$1.to_proto$p,
                                                                            merge: $$let$1.merge,
                                                                            to_json: $$let$1.to_json,
                                                                            from_json_exn: $$let$1.from_json_exn,
                                                                            from_json: $$let$1.from_json
                                                                          })
                                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                                          [
                                                                            15,
                                                                            "expire_time",
                                                                            "expireTime"
                                                                          ],
                                                                          Ocaml_protoc_plugin__Spec.message({
                                                                                name: $$let$2.name,
                                                                                make: $$let$2.make,
                                                                                from_proto: $$let$2.from_proto,
                                                                                from_proto_exn: $$let$2.from_proto_exn,
                                                                                to_proto: $$let$2.to_proto,
                                                                                to_proto$p: $$let$2.to_proto$p,
                                                                                merge: $$let$2.merge,
                                                                                to_json: $$let$2.to_json,
                                                                                from_json_exn: $$let$2.from_json_exn,
                                                                                from_json: $$let$2.from_json
                                                                              })
                                                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                              [
                                                                                16,
                                                                                "valid",
                                                                                "valid"
                                                                              ],
                                                                              Ocaml_protoc_plugin__Spec.bool,
                                                                              false
                                                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                                  [
                                                                                    17,
                                                                                    "ocsp_status",
                                                                                    "ocspStatus"
                                                                                  ],
                                                                                  Ocaml_protoc_plugin__Spec.string,
                                                                                  ""
                                                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                                      [
                                                                                        18,
                                                                                        "ocsp_revoked",
                                                                                        "ocspRevoked"
                                                                                      ],
                                                                                      Ocaml_protoc_plugin__Spec.bool,
                                                                                      false
                                                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                                          [
                                                                                            19,
                                                                                            "ocsp_revoke_reason",
                                                                                            "ocspRevokeReason"
                                                                                          ],
                                                                                          Ocaml_protoc_plugin__Spec.bool,
                                                                                          false
                                                                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                                                              [
                                                                                                20,
                                                                                                "ocsp_revoke_time",
                                                                                                "ocspRevokeTime"
                                                                                              ],
                                                                                              Ocaml_protoc_plugin__Spec.message({
                                                                                                    name: $$let$3.name,
                                                                                                    make: $$let$3.make,
                                                                                                    from_proto: $$let$3.from_proto,
                                                                                                    from_proto_exn: $$let$3.from_proto_exn,
                                                                                                    to_proto: $$let$3.to_proto,
                                                                                                    to_proto$p: $$let$3.to_proto$p,
                                                                                                    merge: $$let$3.merge,
                                                                                                    to_json: $$let$3.to_json,
                                                                                                    from_json_exn: $$let$3.from_json_exn,
                                                                                                    from_json: $$let$3.from_json
                                                                                                  })
                                                                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                                                  [
                                                                                                    21,
                                                                                                    "crl_revoked",
                                                                                                    "crlRevoked"
                                                                                                  ],
                                                                                                  Ocaml_protoc_plugin__Spec.bool,
                                                                                                  false
                                                                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                                                      [
                                                                                                        22,
                                                                                                        "crl_status",
                                                                                                        "crlStatus"
                                                                                                      ],
                                                                                                      Ocaml_protoc_plugin__Spec.string,
                                                                                                      ""
                                                                                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                                                          [
                                                                                                            23,
                                                                                                            "crl_revoked_by",
                                                                                                            "crlRevokedBy"
                                                                                                          ],
                                                                                                          Ocaml_protoc_plugin__Spec.string,
                                                                                                          ""
                                                                                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                                                                                              [
                                                                                                                24,
                                                                                                                "crl_revoke_reason",
                                                                                                                "crlRevokeReason"
                                                                                                              ],
                                                                                                              Ocaml_protoc_plugin__Spec.string,
                                                                                                              ""
                                                                                                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                                                                                  [
                                                                                                                    25,
                                                                                                                    "crl_revoke_time",
                                                                                                                    "crlRevokeTime"
                                                                                                                  ],
                                                                                                                  Ocaml_protoc_plugin__Spec.message({
                                                                                                                        name: $$let$4.name,
                                                                                                                        make: $$let$4.make,
                                                                                                                        from_proto: $$let$4.from_proto,
                                                                                                                        from_proto_exn: $$let$4.from_proto_exn,
                                                                                                                        to_proto: $$let$4.to_proto,
                                                                                                                        to_proto$p: $$let$4.to_proto$p,
                                                                                                                        merge: $$let$4.merge,
                                                                                                                        to_json: $$let$4.to_json,
                                                                                                                        from_json_exn: $$let$4.from_json_exn,
                                                                                                                        from_json: $$let$4.from_json
                                                                                                                      })
                                                                                                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                                                                                                      [
                                                                                                                        26,
                                                                                                                        "create_time",
                                                                                                                        "createTime"
                                                                                                                      ],
                                                                                                                      Ocaml_protoc_plugin__Spec.message({
                                                                                                                            name: $$let$5.name,
                                                                                                                            make: $$let$5.make,
                                                                                                                            from_proto: $$let$5.from_proto,
                                                                                                                            from_proto_exn: $$let$5.from_proto_exn,
                                                                                                                            to_proto: $$let$5.to_proto,
                                                                                                                            to_proto$p: $$let$5.to_proto$p,
                                                                                                                            merge: $$let$5.merge,
                                                                                                                            to_json: $$let$5.to_json,
                                                                                                                            from_json_exn: $$let$5.from_json_exn,
                                                                                                                            from_json: $$let$5.from_json
                                                                                                                          })
                                                                                                                    ]), Ocaml_protoc_plugin__Spec.nil))))))))))))))))))))))))));
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry.app(serialize$1, [
        writer,
        param.id,
        param.org,
        param.name,
        param.key_usage,
        param.key_serial_no,
        param.key_user,
        param.alg,
        param.content,
        param.subject_iin,
        param.subject_bin,
        param.subject_fullname,
        param.subject_organization,
        param.issuer,
        param.issue_time,
        param.expire_time,
        param.valid,
        param.ocsp_status,
        param.ocsp_revoked,
        param.ocsp_revoke_reason,
        param.ocsp_revoke_time,
        param.crl_revoked,
        param.crl_status,
        param.crl_revoked_by,
        param.crl_revoke_reason,
        param.crl_revoke_time,
        param.create_time
      ]);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(id, org, name, key_usage, key_serial_no, key_user, alg, content, subject_iin, subject_bin, subject_fullname, subject_organization, issuer, issue_time, expire_time, valid, ocsp_status, ocsp_revoked, ocsp_revoke_reason, ocsp_revoke_time, crl_revoked, crl_status, crl_revoked_by, crl_revoke_reason, crl_revoke_time, create_time) {
  return {
          id: id,
          org: org,
          name: name,
          key_usage: key_usage,
          key_serial_no: key_serial_no,
          key_user: key_user,
          alg: alg,
          content: content,
          subject_iin: subject_iin,
          subject_bin: subject_bin,
          subject_fullname: subject_fullname,
          subject_organization: subject_organization,
          issuer: issuer,
          issue_time: issue_time,
          expire_time: expire_time,
          valid: valid,
          ocsp_status: ocsp_status,
          ocsp_revoked: ocsp_revoked,
          ocsp_revoke_reason: ocsp_revoke_reason,
          ocsp_revoke_time: ocsp_revoke_time,
          crl_revoked: crl_revoked,
          crl_status: crl_status,
          crl_revoked_by: crl_revoked_by,
          crl_revoke_reason: crl_revoke_reason,
          crl_revoke_time: crl_revoke_time,
          create_time: create_time
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.keychain.v1.Key", spec$1(undefined))(options);
  return function (param) {
    return Curry.app(serialize, [
                param.id,
                param.org,
                param.name,
                param.key_usage,
                param.key_serial_no,
                param.key_user,
                param.alg,
                param.content,
                param.subject_iin,
                param.subject_bin,
                param.subject_fullname,
                param.subject_organization,
                param.issuer,
                param.issue_time,
                param.expire_time,
                param.valid,
                param.ocsp_status,
                param.ocsp_revoked,
                param.ocsp_revoke_reason,
                param.ocsp_revoke_time,
                param.crl_revoked,
                param.crl_status,
                param.crl_revoked_by,
                param.crl_revoke_reason,
                param.crl_revoke_time,
                param.create_time
              ]);
  };
}

function constructor$3(id, org, name, key_usage, key_serial_no, key_user, alg, content, subject_iin, subject_bin, subject_fullname, subject_organization, issuer, issue_time, expire_time, valid, ocsp_status, ocsp_revoked, ocsp_revoke_reason, ocsp_revoke_time, crl_revoked, crl_status, crl_revoked_by, crl_revoke_reason, crl_revoke_time, create_time) {
  return {
          id: id,
          org: org,
          name: name,
          key_usage: key_usage,
          key_serial_no: key_serial_no,
          key_user: key_user,
          alg: alg,
          content: content,
          subject_iin: subject_iin,
          subject_bin: subject_bin,
          subject_fullname: subject_fullname,
          subject_organization: subject_organization,
          issuer: issuer,
          issue_time: issue_time,
          expire_time: expire_time,
          valid: valid,
          ocsp_status: ocsp_status,
          ocsp_revoked: ocsp_revoked,
          ocsp_revoke_reason: ocsp_revoke_reason,
          ocsp_revoke_time: ocsp_revoke_time,
          crl_revoked: crl_revoked,
          crl_status: crl_status,
          crl_revoked_by: crl_revoked_by,
          crl_revoke_reason: crl_revoke_reason,
          crl_revoke_time: crl_revoke_time,
          create_time: create_time
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.keychain.v1.Key", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "KeyContent"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, Key, {
      KeyContent: KeyContent,
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "KeyContent"
              ],
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "Key"
        ]]
    }, V1, {
      Key: Key
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "KeyContent"
                    ],
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "Key"
              ]]
          },
          "V1"
        ]]
    }, Keychain, {
      V1: V1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [[
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            {
                              TAG: /* Module */0,
                              _0: [
                                [
                                  /* Function */0,
                                  "make"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto"
                                ],
                                [
                                  /* Function */0,
                                  "to_json"
                                ],
                                [
                                  /* Function */0,
                                  "from_json"
                                ],
                                [
                                  /* Function */0,
                                  "name"
                                ],
                                [
                                  /* Function */0,
                                  "merge"
                                ],
                                [
                                  /* Function */0,
                                  "to_proto$p"
                                ],
                                [
                                  /* Function */0,
                                  "from_proto_exn"
                                ],
                                [
                                  /* Function */0,
                                  "from_json_exn"
                                ]
                              ]
                            },
                            "KeyContent"
                          ],
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "Key"
                    ]]
                },
                "V1"
              ]]
          },
          "Keychain"
        ]]
    }, Buhta, {
      Keychain: Keychain
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
